// extracted by mini-css-extract-plugin
module.exports = {"modal":"GdprProxyModal_modal__6jM0d","dialog":"GdprProxyModal_dialog__wd3md","icon":"GdprProxyModal_icon__MC67a"};